<button mat-stroked-button (click)="reset()">Reset session</button>
<table mat-table id="indicatorsTable" [dataSource]="indicatorsDataSource" *ngIf="indicatorsDisplayedColumns && indicatorsDisplayedColumns.length > 0">
    <ng-container *ngFor="let column of indicatorsColumns" [cdkColumnDef]="column.columnDef">
        <th mat-header-cell *cdkHeaderCellDef>{{ column.header }}</th>
        <td mat-cell *cdkCellDef="let row" class="{{ column.classIndicator(column.columnDef) }}">{{ column.cell(column.columnDef, row) }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="indicatorsDisplayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: indicatorsDisplayedColumns;"></tr>
</table>
